<template>
    <group-backend-layout page-title="Classrooms">
        <template #page_controls>
            <GroupCreateClassroomModal />
        </template>

        <div class="">
            <div
                v-if="!classrooms.length"
                class="py-8 text-center text-[15px] leading-8"
            >
                <div class="font-semibold">No classrooms ... yet</div>
                <div class="">
                    Classrooms are useful for organizing your students into
                    cohorts and tracking their progress (e.g. “EMTs Summer of
                    {{ dayjs().format("YYYY") }}”)
                </div>
                <Link
                    :href="route('group.classrooms.archived.index')"
                    class="link"
                    v-if="$page.props.classrooms_archived"
                >
                    Show Archived Classrooms
                </Link>
            </div>
            <div class="w-full" v-else>
                <div
                    class="mb-8 box-content flex h-10 w-64 items-center rounded border border-gray-350 text-center text-[15px]"
                >
                    <Link
                        :href="route('group.classrooms.index')"
                        class="flex h-10 flex-grow items-center justify-center border-r border-gray-350 bg-gray-250 px-4 py-2 font-medium hover:cursor-pointer hover:bg-gray-250"
                        >Active ({{ $page.props.classrooms_active }})
                    </Link>
                    <Link
                        :href="route('group.classrooms.archived.index')"
                        class="text-gray-650') flex h-10 flex-grow items-center justify-center border-r border-gray-350 bg-white px-4 py-2 hover:cursor-pointer hover:bg-gray-250"
                        >Archived ({{ $page.props.classrooms_archived }})
                    </Link>
                </div>

                <easy-data-table
                    class="table"
                    :headers="headers"
                    :items="classrooms"
                    :hide-footer="classrooms.length < 10"
                    :rows-per-page="10"
                    :rows-items="[10, 25, 50]"
                    must-sort
                    buttons-pagination
                    :body-row-class-name="tableRowClass"
                >
                    <template #item-name="classroom">
                        <Link
                            class="link block"
                            :href="
                                route('group.classroom.show', {
                                    classroom: classroom.id,
                                })
                            "
                        >
                            <text-clamp
                                autoResize
                                :max-lines="1"
                                location="middle"
                                :text="classroom.name"
                            />
                        </Link>
                    </template>

                    <template #item-active_students_count="classroom">
                        <div class="whitespace-nowrap">
                            {{ classroom.active_students_count }}
                            <span
                                v-if="classroom.pending_students_count"
                                class="ml-4 rounded bg-gray-300 px-2 py-1 text-[13px] font-medium"
                                >+{{
                                    classroom.pending_students_count
                                }}&nbsp;</span
                            >
                        </div>
                    </template>

                    <template #item-expired_students_count="classroom">
                        {{ classroom.expired_students_count }}
                    </template>

                    <template #item-instructor.full_name="classroom">
                        <text-clamp
                            autoResize
                            :max-lines="1"
                            location="middle"
                            :text="classroom.instructor.full_name"
                        />
                    </template>

                    <template #item-created_at="classroom">
                        <div class="whitespace-nowrap">
                            {{
                                dayjs(classroom.created_at)
                                    .utc(true)
                                    .tz($page.props.auth.user.timezone)
                                    .format($page.props.date_formats.short_nice)
                            }}
                        </div>
                    </template>
                    <template #item-actions="classroom">
                        <dropdown open-from="right" :px-width="260">
                            <template #button>
                                <more-dots-button />
                            </template>
                            <template #content>
                                <ul class="rounded border">
                                    <li>
                                        <GroupArchiveClassroomModal
                                            :classroom="classroom"
                                        />
                                    </li>
                                </ul>
                            </template>
                        </dropdown>
                    </template>
                </easy-data-table>
            </div>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import MoreDotsButton from "@/Components/MoreDotsButton";
import Dropdown from "@/Components/Dropdown";
import GroupArchiveClassroomModal from "@/Components/GroupArchiveClassroomModal";
import GroupCreateClassroomModal from "@/Components/GroupCreateClassroomModal";

export default {
    name: "GroupClassroomsIndex",
    components: {
        GroupCreateClassroomModal,
        GroupArchiveClassroomModal,
        GroupBackendLayout,
        MoreDotsButton,
        Dropdown,
    },
    props: {
        classrooms: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Classroom",
                    value: "name",
                    sortable: true,
                },
                {
                    text: "Students",
                    value: "active_students_count",
                    sortable: true,
                },
                {
                    text: "Expired",
                    value: "expired_students_count",
                    sortable: true,
                },
                {
                    text: "Instructor",
                    value: "instructor.full_name",
                    sortable: true,
                },
                {
                    text: "Date Created",
                    value: "created_at",
                    sortable: true,
                },
                {
                    text: "",
                    value: "actions",
                    width: 30,
                },
            ],
        };
    },
    methods: {
        tableRowClass(classroom) {
            if (classroom.archived_at) {
                return "text-gray-600";
            }
        },
    },
};
</script>
